/**
 * Converts a hex color string to RGB values.
 * @param hexColor - A hex color string (e.g., "#ff0000")
 * @returns A tuple of [red, green, blue] values (0-255)
 */
function hexToRgb(hexColor: string): [number, number, number] {
  return [
    parseInt(hexColor.slice(1, 3), 16),
    parseInt(hexColor.slice(3, 5), 16),
    parseInt(hexColor.slice(5, 7), 16),
  ];
}

/**
 * Creates an rgba color string with 30% opacity from a hex color.
 * @param hexColor - A hex color string (e.g., "#ff0000")
 * @returns An rgba color string (e.g., "rgba(255,0,0,0.3)")
 */
export function lightenWithRgba(hexColor: string) {
  return `rgba(${hexToRgb(hexColor).join(",")},0.3)`;
}
